// extracted by mini-css-extract-plugin
export default {"root":"LeftPanel_root__dq3OK"};